import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,Switch,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles

var CryptoJS = require("crypto-js");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


var sacco= ''
var bizuserid= ''
var token= ''

class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{},
    };
  
    componentDidMount(){

      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }

      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

    }

    calculatecredittotal=()=>{
      var Total=0
      this.props.sheetitems.map(
        (item)=>{
          Total+=Number(item.Credit)
        })
  
      return Total.toFixed(2);
  
    }
  
    render() {
      return (
        <div style={{padding:20}}>
         <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                
                  </Col>

       </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>MEMBER PAYMENTS REPORT FOR {this.props.account} FROM: {this.props.dateone}  TO: {this.props.datetwo}</h3>

             <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Member</th>

                          <th>Date</th>
                          <th>Amount paid</th>
                          <th>Balance</th>
                          <th>Desc</th>
                          <th>Journal no</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.props.sheetitems.map(
                        (item)=>(
                          <tr>
                          <td>{item.item_no}</td>
                          <td>{item.member_account_name}</td>

                          <td>{item.date}</td>
                          <td className="align-right">{<CurrencyFormat value={item.Credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td>{item.description}</td>
                          <td>{item.journal_no}</td>

                          </tr>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td></td>
                        <td></td>

                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculatecredittotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td></td>

                        <td></td>
                        <td></td>
                        </tr>

                    </tbody>
                </reactstrp.Table> 
        </div>
      );
    }
  }


class MemberAutoPaymentsReport extends React.Component {

  state = {
    ...initialReportEmailState(),
    ledgeraccounts:[],
    companyprofile: {},
    sheetitems:[],
    dateone:'',
    datetwo:'',
    account:'',
    totaldebit:0,
    totalcredit:0,
    datarequested:false,
    searchbyjno:false,
    journalno:0,
    autopaymentlist:[],
    members:[],
    selectedaccount:''

   };

   componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   
   }else{
      sacco= ''
      bizuserid= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data = new FormData();
    form_data.append('sacco', sacco);
    axios.post(serverconfig.backendserverurl+`/customqueries/getjournalaccounts`, form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          ledgeraccounts:JSON.parse(res.data.report)
        })
      })


      axios.get(`${serverconfig.backendserverurl}/api/saccosedit/${sacco}`)
      .then(res => {
        this.setState((prev) => ({
          companyprofile: res.data,
          receiving_email: prev.receiving_email || res.data.company_email || '',
          autopaymentlist: res.data.automated_memberpayments_fromsavings === undefined ? [] : JSON.parse(res.data.automated_memberpayments_fromsavings),
        }));
      })

      axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
      .then(res => {
  
        //console.log(res.data)
        this.setState({
          members:res.data
        })
  
      })
  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString[0]});
     this.setState({ datetwo: dateString[1]});
   } 


   
     //calculate total savings
  calculatedebittotal=()=>{
    var Total=0
    this.state.sheetitems.map(
      (item)=>{
        Total+=Number(item.Debit)
      })

    return Total.toFixed(2);

  }

  calculatecredittotal=()=>{
    var Total=0
    this.state.sheetitems.map(
      (item)=>{
        Total+=Number(item.Credit)
      })

    return Total.toFixed(2);

  }


   //search sales method
   searchSales=()=>{
      if(this.state.account===''||this.state.dateone===''||this.state.datetwo===''){
        message.error("Please select account or dates missing")
        return;
      }

      let form_data = new FormData();
      form_data.append('dateone', this.state.dateone);
      form_data.append('datetwo', this.state.datetwo);
      form_data.append('account', this.state.account);
      form_data.append('sacco', sacco);
      form_data.append('selectedaccount', this.state.selectedaccount);

      submitReportWithEmail({
        reportKey: REPORT_KEYS.MEMBER_AUTO_PAYMENTS,
        params: {
          dateone: this.state.dateone,
          datetwo: this.state.datetwo,
          account: this.state.account,
          sacco,
          selectedaccount: this.state.selectedaccount,
        },
        emailReport: this.state.email_report,
        receivingEmail: this.state.receiving_email,
        endpoint: serverconfig.backendserverurl + '/customqueries/getMemberAutoPaymentsReport',
        formData: form_data,
        setLoading: (v) => this.setState({ datarequested: v }),
        onSuccess: (res) => {
          this.setState({ sheetitems: JSON.parse(res.data.report) });
        },
      });
  }
   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
          <Spin indicator={antIcon} />
          </div>
        )
  
      }else{

        return(
          <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              totaldebit={this.calculatedebittotal()} 
              totalcredit={this.calculatecredittotal()} 
              dateone={this.state.dateone}
              datetwo={this.state.datetwo}
              sheetitems={this.state.sheetitems}
              account={this.state.account}
              ref={el => (this.componentRef = el)} /> 
            </div>
  
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="MEMBER AUTOPAYMENTS REPORT" key="1">

              <div style={{display:'flex',justifyContent:'flex-start',flexDirection:'row'}}>
                {!this.state.email_report ? (
                <>
                <ReactToPrint
                  trigger={() => 
                  <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                  Print
                  </Button>
                  }
                  content={() => this.componentRef}
                  />

                &nbsp;&nbsp;

                <ExcelFile filename={"Pisacco - Member payments report for "+this.state.account+" from "+this.state.dateone+" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
                  <ExcelSheet data={this.state.sheetitems} name={"Payments"}>
                      <ExcelColumn label="No" value="item_no"/>
                      <ExcelColumn label="Date" value="date"/>
                      <ExcelColumn label="Member" value="member_account_name"/>
                      <ExcelColumn label="Description" value="description"/>
                      <ExcelColumn label="Journal no" value="journal_no"/>
                      <ExcelColumn label="Amount" value="Credit"/>
                      <ExcelColumn label="Balance" value="balance"/>
                  </ExcelSheet>
                </ExcelFile>
                </>
                ) : null}

               </div>
               <br></br>
               <br></br>


              <Form  layout="inline" >

                    <FormItem label="Select Payment">
                     <Select 
                     placeholder="Account"
                     style={{ width: 200 }} 
                     value={this.state.account} 
                     onChange={(val)=>{this.setState({account:val})}}
                      
                     showSearch
                     optionFilterProp="children"
                     onFocus={this.onFocus}
                     onBlur={this.onBlur}
                     onSearch={this.onSearch}
                     filterOption={(input, option) =>
                       option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                     }                     
                      >
                       {this.state.autopaymentlist.map(
                         (acc_nt)=>(
                           <Option value={acc_nt.account_tocredit}>{acc_nt.account_tocredit}</Option>
                         ))}
                     </Select>
                 </FormItem>


                 <FormItem label="Member Account">
                    <Select 
                    placeholder="Account No | Name" 
                    style={{ width:300 }} 
                    value={this.state.selectedaccount}
                    onChange={(val)=>{this.setState({selectedaccount:val})}} 
                    showSearch
                    optionFilterProp="children"
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}         
                    >
                      <Option value={''}>All members</Option>
                      {this.state.members.map(
                        (accnt)=>(
                          <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                        ))}
                    </Select>
                </FormItem>
 
                  <FormItem label="Date Range">
                      <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                  </FormItem>
  
              
                <ReportEmailControls
                  emailReport={this.state.email_report}
                  receivingEmail={this.state.receiving_email}
                  onEmailReportChange={(val) => this.setState({ email_report: val })}
                  onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
                  companyEmail={this.state.companyprofile.company_email}
                />

                <FormItem>
                <Button onClick={this.searchSales} type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
                </FormItem> 
  
             </Form>
  
             <br></br>

             <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Member</th>

                          <th>Date</th>
                          <th>Amount paid</th>
                          <th>Balance</th>
                          <th>Desc</th>
                          <th>Journal no</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.sheetitems.map(
                        (item)=>(
                          <tr>
                          <td>{item.item_no}</td>
                          <td>{item.member_account_name}</td>

                          <td>{item.date}</td>
                          <td className="align-right">{<CurrencyFormat value={item.Credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td>{item.description}</td>
                          <td>{item.journal_no}</td>

                          </tr>
                        ))}
                        <tr>
                        <td style={{fontWeight:'bolder'}}>Total</td>
                        <td></td>
                        <td></td>

                        <td className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculatecredittotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                        <td></td>

                        <td></td>
                        <td></td>
                        </tr>

                    </tbody>
                </reactstrp.Table> 

              </Panel>
              </Collapse>
          </div>
       )        

       }

}

}
export default MemberAutoPaymentsReport; 
